<template>
  <span class="aisea-text-18-600-pure-white menu-title">{{ menuTitle }}</span>
</template>

<script>
/**
 * 表示するタイトルのコンポーネント
 * @parent M.MenuBar
 * @props menuTitle: 表示するタイトル
 */
export default {
  name: "A.MenuTitle",
  props: {
    menuTitle: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-title {
  line-height: 18px;
}
</style>
